<template>
    <div class="Home" @scroll="scrollHome">
        <CustomHeader @clickLeft="$backPre" :bgColor="headBgColor" :leftText="pagename" :color="headColor" />
        <!-- <div class="swiper-wrap" v-if="homeConfig.find(item => item.type == 'SWIPE')"> -->
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" :show-indicators="false">
            <van-swipe-item @click="clcikSwipeItem(item)" v-for="(item, index) in homeConfig.find(item => item.type == 'SWIPE').items" :key="index">
                <div
                    class="swipeImg bgi noImg"
                    :style="{
                        backgroundImage: `url('${$getImageUrl(item.imageUrl)}')`,
                    }"
                ></div>
            </van-swipe-item>
        </van-swipe>
        <!-- </div> -->
        <div class="select-wrap">
            <van-tabs>
                <van-tab title="国内">
                    <van-cell style="color: #000;" @click="showArea = true" :title="routeQuery.selectedAreaObj.name" is-link />
                    <van-cell is-link :value="dataLength" class="selectDate-wrap">
                        <template #title>
                            <div class="jc-between">
                                <div class="dateItem clickOuterActive" @click="clickDate('start')">
                                    <div>入住日期</div>
                                    <div>
                                        <span>{{ routeQuery.startTime | formatDate }}</span>
                                        <span>周{{ routeQuery.startTime | formatWeek }}</span>
                                    </div>
                                </div>
                                <div class="dateItem clickOuterActive" @click="clickDate('end')">
                                    <div>离店日期</div>
                                    <div>
                                        <span>{{ routeQuery.endTime | formatDate }}</span>
                                        <span>周{{ routeQuery.endTime | formatWeek }}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </van-cell>
                    <van-cell is-link class="searchKeyword">
                        <template #title>
                            <input v-model="routeQuery.fuzzySearch" type="text" placeholder="搜索酒店/地名/关键词" />
                        </template>
                    </van-cell>
                    <!-- <van-cell is-link class="starLevel" @click="showStarLevel = true">
                        <template #title>
                            <div>{{ routeQuery.selectedStar.title }}</div>
                        </template>
                    </van-cell> -->
                    <van-button @click="clickSearch" style="margin: 5vw 0 0;font-weight: bold;" color="linear-gradient(90deg,#fde59f,#ebb06c)" round block
                        >搜索</van-button
                    >
                </van-tab>
                <van-tab @click="$toast(`${item}酒店暂未开放`)" disabled v-for="item in ['海外', '港澳台']" :title="item" :key="item"></van-tab>
            </van-tabs>
        </div>
        <div v-if="homeConfig.find(item => item.type == 'RICHTEXT')">
            <div v-html="homeConfig.find(item => item.type == 'RICHTEXT').items"></div>
        </div>
        <van-popup v-model="showArea" round position="bottom" :style="{ height: '50%' }">
            <van-area title="目的地" :area-list="areaList" @cancel="showArea = false" @confirm="confirmArea" />
        </van-popup>
        <van-popup v-model="showDate" round position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                @cancel="showDate = false"
                @confirm="confirmDate"
                type="date"
                :title="`${dateType == 'start' ? '请选择入住时间' : '请选择离店日期'}`"
                :min-date="minDate"
                :max-date="maxDate"
            />
        </van-popup>
        <van-popup v-model="showStarLevel" round position="bottom" :style="{ height: '18%' }">
            <div class="star-wrap">
                <div>请选择星级</div>
                <div class="starList">
                    <div :class="{ activeStar: item.active }" v-for="(item, index) in starLevels" :key="index" @click="selectStar(item, index)">
                        <span>{{ item.title }}</span>
                        <div class="starActiveIcon" v-if="item.active"><div>√</div></div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import areaList from "@/utils/area.js";
import { Toast } from "vant";
import { searchParamsKey } from "@/utils/variable";
import { getPageByPageid } from "@/api/page";
import { login } from "@/api/login";
import { msUserInfo } from "@/utils/variable";
const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
let initRouteQuery = {
    startTime: today,
    endTime: today + 1000 * 60 * 60 * 24,
    selectedStar: {
        index: -1,
        title: "星级/价格",
    },
    selectedAreaObj: {
        code: null,
        name: "目的地",
    },
    fuzzySearch: "",
};

export default {
    data() {
        return {
            showArea: false,
            showDate: false,
            showStarLevel: false,
            areaList,
            minDate: new Date(today),
            maxDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365),
            currentDate: new Date(today),
            dateType: "start",
            starLevels: [
                { title: "经济型", active: false },
                { title: "舒适/三星", active: false },
                { title: "高档/四星", active: false },
                { title: "豪华/五星", active: false },
            ],
            routeQuery: JSON.parse(JSON.stringify(initRouteQuery)),
            homeConfig: [
                { type: "SWIPE", items: [] },
                { type: "RICHTEXT", items: "" },
            ],
            headColor: "#fff",
            headBgColor: "transparent",
            pagename: "",
        };
    },
    beforeRouteEnter(to, from, next) {
        let splitArr = location.href.split("reqData=");
        if (splitArr.length == 2) {
            login({ reqData: unescape(splitArr[1]) })
                .then(res => {
                    if (res.code === 200) {
                        localStorage[msUserInfo] = JSON.stringify(res.data);
                        next();
                    } else {
                        next(vm => {
                            vm.$router.push("/noPermission");
                        });
                    }
                })
                .catch(err => {
                    next(vm => {
                        vm.$router.push("/noPermission");
                    });
                });
        } else {
            next();
        }
    },
    created() {
        // let reqData = this.$route.query;
        // console.log(this.$route.query);
        this.getHomeConfig();
        this.routeQuery = localStorage[searchParamsKey]
            ? { ...JSON.parse(localStorage[searchParamsKey]), startTime: today, endTime: today + 1000 * 60 * 60 * 24 }
            : JSON.parse(JSON.stringify(initRouteQuery));
        if (this.routeQuery.selectedStar.index != -1) {
            this.starLevels[this.routeQuery.selectedStar.index].active = true;
        }
    },
    computed: {
        dataLength() {
            return `共${Math.floor(
                (new Date(this.routeQuery.endTime).getTime() - new Date(this.routeQuery.startTime).getTime()) / (1000 * 60 * 60 * 24)
            )}晚`;
        },
    },
    filters: {
        formatDate(date) {
            date = new Date(date).toLocaleDateString();
            let arr = date.split("/");
            return `${arr[1]}月${arr[2]}日`;
        },
        formatWeek(week) {
            week = new Date(week).getDay();
            let weeks = ["一", "二", "三", "四", "五", "六", "日"];
            if (week >= 1 && week <= 7) {
                return weeks[week - 1];
            } else {
                return weeks[0];
            }
        },
    },
    methods: {
        clcikSwipeItem(swipeItem) {
            console.log(swipeItem);
            if (swipeItem.linkType == "1") {
                location = swipeItem.link;
            }
        },
        scrollHome(e) {
            if (e.target.scrollTop >= 1) {
                this.headColor = "#333";
                this.headBgColor = "#fff";
            } else {
                this.headColor = "#fff";
                this.headBgColor = "transparent";
            }
        },
        getHomeConfig() {
            getPageByPageid("home").then(res => {
                if (res.code === 200) {
                    this.homeConfig = JSON.parse(res.data.configs);
                    this.pagename = res.data.pagename;
                    if (this.pagename) {
                        document.title = this.pagename;
                    }
                }
            });
        },
        clickSearch() {
            this.$router.push({ path: "/hotelList" });
            localStorage[searchParamsKey] = JSON.stringify(this.routeQuery);
        },
        selectStar(selectedItem, selectedIndex) {
            let status = !selectedItem.active;
            this.starLevels.forEach(item => {
                item.active = false;
            });
            this.starLevels[selectedIndex].active = status;
            this.$forceUpdate();
            if (status) {
                this.routeQuery.selectedStar = { title: selectedItem.title, index: selectedIndex };
            } else {
                this.routeQuery.selectedStar = {
                    index: -1,
                    title: "星级/价格",
                };
            }
            this.showStarLevel = false;
        },
        confirmArea(e) {
            this.routeQuery.selectedAreaObj = e[2];
            this.showArea = false;
        },
        clickDate(type) {
            this.showDate = true;
            this.dateType = type;
            if (type == "start") {
                this.currentDate = new Date(this.routeQuery.startTime);
            } else {
                this.currentDate = new Date(this.routeQuery.endTime);
            }
        },
        confirmDate(e) {
            let DateTime = e.getTime();
            if (this.dateType == "start") {
                if (this.routeQuery.endTime - DateTime >= 1000 * 60 * 60 * 24) {
                    this.routeQuery.startTime = DateTime;
                } else {
                    return Toast("开始时间应小于结束时间");
                }
            } else {
                if (DateTime - this.routeQuery.startTime >= 1000 * 60 * 60 * 24) {
                    this.routeQuery.endTime = DateTime;
                } else {
                    return Toast("结束时间应大于开始时间");
                }
            }
            this.showDate = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.Home {
    // $swipeTop: -0.88;
    // $swipeRadiusSize: 400vw;
    $swipeHeight: 60vw;
    height: calc(100vh - 50px);
    width: 100vw;
    position: relative;
    overflow-x: hidden;
    overflow-y: scroll;
    /* background-color: rgb(248, 248, 248); */
    background-color: #ececec;
    .my-swipe {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100vw;
        height: $swipeHeight;
        // height: calc((1 + #{$swipeTop}) * #{$swipeRadiusSize});
        .van-swipe-item {
            position: relative;
            color: #fff;
            font-size: 20px;
            line-height: 150px;
            text-align: center;
            background-color: #39a9ed;
            width: 100%;
            height: 100%;
            .swipeImg {
                width: 100%;
                height: 100%;
            }
        }
    }
    .swiper-wrap {
        // width: $swipeRadiusSize;
        // height: $swipeRadiusSize;
        // position: absolute;
        // top: $swipeTop * $swipeRadiusSize;
        // left: 50%;
        // transform: translateX(-50%);
        // border-radius: 50%;
        // background-color: $primary;
        // overflow: hidden;
        // .my-swipe {
        //     position: absolute;
        //     bottom: 0;
        //     left: 50%;
        //     transform: translateX(-50%);
        //     width: 100vw;
        //     height: calc((1 + #{$swipeTop}) * #{$swipeRadiusSize});
        //     .van-swipe-item {
        //         position: relative;
        //         color: #fff;
        //         font-size: 20px;
        //         line-height: 150px;
        //         text-align: center;
        //         background-color: #39a9ed;
        //         width: 100%;
        //         height: 100%;
        //         .swipeImg {
        //             width: 100%;
        //             height: 100%;
        //         }
        //     }
        // }
    }
    .select-wrap {
        width: 92vw;
        box-shadow: 0 0 4px 1px rgba($color: #000000, $alpha: 0.1);
        border-bottom-left-radius: 2vw;
        border-bottom-right-radius: 2vw;
        overflow: hidden;
        position: relative;
        z-index: 2;
        // margin: calc((1 + #{$swipeTop} - 0.065) * #{$swipeRadiusSize}) auto 0;
        margin: calc(#{$swipeHeight} - 46px - 11.5vw) auto 3vw;
        // transform: translateY(-11.5vw);
        box-sizing: border-box;
        /deep/.van-tabs__wrap {
            border-bottom: 1px solid rgb(243, 243, 243);
            transform: translateY(0.15vw);
            .van-tabs__nav {
                background-color: transparent;
            }
            .van-tab {
                font-size: 3.7vw;
                font-weight: bold;
                border-top-left-radius: 2vw;
                border-top-right-radius: 2vw;
            }
            .van-tab--disabled {
                // visibility: hidden;
                background-color: #e3e3e3;
                border: 1px solid rgb(221, 221, 221);
            }
            .van-tab--active {
                /* background-color: #fbe3b5; */
                background: linear-gradient(90deg, #fde59f, #ebb06c);
                border: 1px solid #ffd88e;
                font-weight: bold;
            }
            .van-tabs__line {
                display: none;
            }
        }
        /deep/.van-tabs__content {
            background-color: #fff;
            .van-tab__pane {
                padding: 5vw 2.5vw;
                .van-button {
                    width: 55%;
                    left: 50%;
                    transform: translateX(-50%);
                    color: #333 !important;
                    font-size: 4.1vw;
                }
            }
        }
        /deep/.van-cell {
            padding: 10px 4px;
        }
        .selectDate-wrap {
            align-items: center;
            /deep/.van-cell__title {
                flex: 3;
            }
            /deep/.van-cell__value {
                color: #333;
            }
            &:active {
                background-color: #fff;
            }
            .dateItem {
                font-size: 2.8vw;
                // &:active {
                //     background-color: #f2f3f5;
                // }
                > div:last-child {
                    > span:first-child {
                        font-size: 4.4vw;
                        margin-right: 2vw;
                    }
                }
            }
        }
        .searchKeyword {
            &:active {
                background-color: #fff;
            }
            input {
                border: none;
                outline: none;
                width: 100%;
            }
        }
    }
    /deep/ .van-hairline--bottom::after {
        border-width: 0;
    }
    .star-wrap {
        padding: 4vw;
        > div:first-child {
            margin: 2.5vw 0 5vw;
        }
        .starList {
            display: flex;
            justify-content: space-between;
            font-size: 3.1vw;
            > div {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-shrink: 0;
                background-color: rgb(235, 235, 235);
                color: rgb(88, 88, 88);
                padding: 2vw;
                width: 24%;
                box-sizing: border-box;
                border-radius: 1vw;
                position: relative;
                overflow: hidden;
            }
            .activeStar {
                background-color: #fff1f1;
                color: #f45552;
            }
            .starActiveIcon {
                border-radius: 50%;
                width: 7vw;
                height: 7vw;
                background-color: #ff5050;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-shrink: 0;
                position: absolute;
                bottom: -4vw;
                right: -3vw;
                > div {
                    transform: translate(98%, 5%);
                    color: #fff;
                    font-size: 2.8vw;
                }
            }
        }
    }
}
</style>
